import { utils, writeFileXLSX } from 'xlsx';
export const convertJsonToXlsx = function (arrayOfDsonData, fileName) {
  let sheetName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Data';
  let headers = arguments.length > 3 ? arguments[3] : undefined;
  let headersOrigin = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'A1';
  // Generate worksheet and workbook
  const worksheet = utils.json_to_sheet(arrayOfDsonData);
  const workbook = utils.book_new();
  utils.book_append_sheet(workbook, worksheet, sheetName);

  // Fix headers
  if (headers) {
    utils.sheet_add_aoa(worksheet, [headers], {
      origin: headersOrigin
    });
  }

  // Create an XLSX file and try to save fileName
  writeFileXLSX(workbook, `${fileName}.xlsx`);
};